import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './ResponsiveCopy.scss';

const ResponsiveCopy = ({ className = '', children }) => (
    <p className={getClassName(styles['responsive-text'], className)}>
        {children}
    </p>
);

export default ResponsiveCopy;
